import { combineReducers } from "redux";

import authReducer from "./auth.reducer";
import paymentReducer from "./payment.reducer";
import userReducer from "./user.reducer";
import entriesReducer from "./entries.reducer";
import tractorReducer from "./tractor.reducer";
import leasingReducer from "./leasing.reducer";
import investmentReducer from "./investment.reducer";

export default combineReducers({
  auth: authReducer,
  payments: paymentReducer,
  users: userReducer,
  entries: entriesReducer,
  tractor: tractorReducer,
  leasing: leasingReducer,
  investment: investmentReducer,
});
